import { render, staticRenderFns } from "./wangEditor.vue?vue&type=template&id=9cef1d6a&lang=html&"
import script from "./wangEditor.vue?vue&type=script&lang=js&"
export * from "./wangEditor.vue?vue&type=script&lang=js&"
import style0 from "./wangEditor.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports